import Space from './Space';
import DrawerZone from './DrawerZone';
import ShelfZone from './ShelfZone';
import HorizontalDivider from './HorizontalDivider';

class CabinetZoneConfigurator {

    private mChildren: any[];

    private target: HTMLElement;

    // TODO: Type the parameters correctly
    constructor(zones: { [key: string]: any }[], fronts: any[], setScript: () => void, setParameters: () => void) {

        this.mChildren = [];

        const templates: HTMLElement = document.querySelector<HTMLElement>('[data-id="templates"]')!;
        const template: HTMLElement = templates.querySelector<HTMLElement>('[data-id="zones"]')!;
        const cloned: HTMLElement = template.cloneNode(true) as HTMLElement;
        // create target for configuration
        this.target = document.querySelector<HTMLElement>('div[data-id="configuration"]')!;
        this.target.appendChild(cloned);

        for(let zone of zones) {
            for(let key in zone) { // Space, ShelfZone, DrawerZone, HorizontalDivider

                console.log(key + " -> " + zone[key]);

                let idx = this.mChildren.length;

                switch(key){
                    case "Space": this.mChildren.push(new Space(idx, zone[key], fronts, setScript, setParameters)); // append
                        break;
                    case "HorizontalDivider": this.mChildren.push(new HorizontalDivider());
                        break;
                    case "ShelfZone": this.mChildren.push(new ShelfZone(idx, zone[key], fronts, setScript, setParameters));
                        break;
                    case "DrawerZone": this.mChildren.push(new DrawerZone(idx, zone[key], fronts, setScript, setParameters));
                        break;
                    default: console.log("Unknown: " + key);
                        break;
                }   
            }
        }
    }

    public cleanup(): void {
        const templates: NodeListOf<HTMLElement> = this.target.querySelectorAll<HTMLElement>('[data-id="zones"]');
        for(let template of templates) {
            template.remove();
        }
    }

}

export default CabinetZoneConfigurator;
